import React, {useContext, useEffect} from 'react';
import {authContext} from '../Context/Authentication/authContext';
import Predictions from '../Predictions/Predictions';
import DaysOnMarket from './Components/DaysOnMarket';
import HomeSales from './Components/HomeSales';
import Population from './Components/Population';
import Permits from './Components/Permits';
import Price from './Components/Price';
import Msp from './Components/Msp';
import Rentals from './Components/Rentals';
import Demographic from './Components/Demographic';
import TravelTime from './Components/TravelTime'
import Crime from './Components/Crime';
import MonthsOfSupply from './Components/MonthsOfSupply';
import PropertyType from './Components/PropertyType';
import './Tabs.scss';
import {Tabs, Tab, Box} from '@mui/material';
import {a11yProps} from '../Helpers/helpers'


const TABS = [
  {name: 'Home sales', title: 'Home Sales'},
  {name: 'Days on market', title: 'Days On Market'},
  {name: 'Price', title: 'Price'},
  {name: 'MSP', title: 'Median Sales Price'},
  {name: 'Months of Supply', title: 'Months of Supply'},
  {name: 'Rentals', title: 'Rentals'},
  {name: 'Population', title: 'Population'},
  {name: 'Travel Time', title: 'Travel Time'},
  {name: 'Crime', title: 'Crime Data'},
  {name: 'Permits', title: 'Permits'},
  {name: 'Demographics', title: 'Demographics'},
  {name: 'Property Type', title: 'Property Type'},
  {name: 'Prediction', title: 'Prediction'},
]

const ADJUSTED_PREDICTIONS = ['Home sales', 'Days on market', 'Price', 'MSP']
const PER_TABS = ['Price', 'MSP']
const DEMOGRAPHICS_TABS = ['Demographics']
const CRIME_TABS = ['Crime']

const CityPredictionTabs = () => {
  const {state, dispatch}: any = useContext(authContext);

  useEffect(() => {
    if (state?.filters?.city?.length > 1) {
      handleSelectedTab(state.selectedTab || 'Home sales');
    }
  }, [state?.filters?.city]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    handleSelectedTab(newValue);
    // if (!ADJUSTED_PREDICTIONS.includes(newValue)) {
    //   dispatch({
    //     type: 'APPLY_FILTER',
    //     payload: {
    //       ...state.filters,
    //       adjustedPredictions: false,
    //       submitAdjustedPrediction: false,
    //       refreshAdjustedPredictionSubmit: false
    //     },
    //   });
    // }
  };


  const handleSelectedTab = (val: string) => {
    console.log(val)
    dispatch({
      type: 'APPLY_FILTER',
      payload: {
        ...state.filters,
        trackEvent:'tabChange'
      },
    });
    dispatch({
      type: 'SET_TAB_SELECTION',
      payload: val,
    });
    if (!PER_TABS.includes(val)) {
      dispatch({
        type: 'APPLY_FILTER',
        payload: {
          ...state.filters,
          value: 'trend',
        },
      });
    }
    if (DEMOGRAPHICS_TABS.includes(val)) {
      dispatch({
        type: 'APPLY_FILTER',
        payload: {
          ...state.filters,
          demographicValue: 'Age',
        },
      });
    }
    if (CRIME_TABS.includes(val)) {
      dispatch({
        type: 'APPLY_FILTER',
        payload: {
          ...state.filters,
          crimeType: 'Property crime',
        },
      });
    }
    // if (!ADJUSTED_PREDICTIONS.includes(val)) {
    //   dispatch({
    //     type: 'APPLY_FILTER',
    //     payload: {
    //       ...state.filters,
    //       adjustedPredictions: false,
    //       submitAdjustedPrediction: false
    //     },
    //   });
    // }
  };

  console.log(TABS)

  return (
    <div className='tabs-main'>
      <Box className='tabs-main__menuContainer'>
        <Tabs
          value={state.selectedTab}
          onChange={handleChange}
          variant='scrollable'
          scrollButtons
          allowScrollButtonsMobile
          selectionFollowsFocus
          TabIndicatorProps={{
            style: {
              backgroundColor: '#fff',
            }
          }}
        >
          {TABS.map((tabItem: any, i: number) => (
              <Tab
                className='tabs-main__menuContainer__menuItem'
                value={tabItem.name}
                sx={{minWidth: 'fit-content', flex: 1}}
                label={tabItem.title}
                // disabled={state?.filters?.city?.length > 1 && tabItem.name === 'Prediction'}
                style={{
                  backgroundColor: state?.selectedTab === tabItem.name ? '#f7b047' : '',
                  borderRadius: state?.selectedTab === tabItem.name ? '4px' : '',
                  fontWeight: state?.selectedTab === tabItem.name ? 'bold' : 'normal',
                  color:'#fff',
                }}
                {...a11yProps(i)}
              />
            )
          )}
        </Tabs>
      </Box>
      {state?.selectedTab === 'Price' && <Price/>}
      {state?.selectedTab === 'Prediction' && <Predictions/>}
      {state?.selectedTab === 'Home sales' && <HomeSales/>}
      {state?.selectedTab === 'Days on market' && <DaysOnMarket/>}
      {state?.selectedTab === 'Population' && <Population/>}
      {state?.selectedTab === 'Permits' && <Permits/>}
      {state?.selectedTab === 'MSP' && <Msp/>}
      {state?.selectedTab === 'Rentals' && <Rentals/>}
      {state?.selectedTab === 'Demographics' && <Demographic/>}
      {state?.selectedTab === 'Travel Time' && <TravelTime/>}
      {state?.selectedTab === 'Crime' && <Crime/>}
      {state?.selectedTab === 'Months of Supply' && <MonthsOfSupply/>}
      {state?.selectedTab === 'Property Type' && <PropertyType type={'city'}/>}
    </div>
  );
};

export default React.memo(CityPredictionTabs);
